import { httpV1 as http } from '@/services/api';

const dashboardPath = '/dashboard/dashboard-admin';
const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function getProductionPerDay(params) {
  return http
    .get(`${dashboardPath}/production-per-day`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getPayoffBankSlips(params) {
  return http
    .get(`${dashboardPath}/payoff-bank-slips`, { params })
    .then(({ data }) => data);
}

export async function getProposalStatusByPromoter(params) {
  return http
    .get(`${ALT_API_URL}${dashboardPath}/proposal-status-by-promoter`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getPromoterBalance(params) {
  return http
    .get(`${dashboardPath}/promoter-balance`, { params })
    .then(({ data }) => data);
}

export async function getSelfieStatistics(params) {
  return http
    .get(`${dashboardPath}/selfie-statistics`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProposalStatus(params) {
  return http
    .get(`${dashboardPath}/proposal-status-chart`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProposalPaymentByScore(params) {
  return http
    .get(`${dashboardPath}/proposal-payment-by-score`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getWarranty(params) {
  return http
    .get(`${dashboardPath}/warranty-chart`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getUserStatus(params) {
  return http
    .get(`${dashboardPath}/user-status`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProductionSummary(params) {
  return http
    .get(`${dashboardPath}/production-summary`, { params })
    .then(({ data }) => data);
}

export async function getCorbanProduction(params) {
  return http
    .get(`${dashboardPath}/promoter-monthly-production`, { params })
    .then(({ data }) => data);
}

export async function fetchPromoterProductionCashbackCommission(dateRange, promoters) {
  const params = {
    ...dateRange,
    promoters,
  };

  return http
    .get(`${dashboardPath}/promoter-production-cashback-commission`, { params })
    .then(({ data }) => data);
}

export async function getPromoterInvoiceEmissionData(params) {
  return http
    .get(`${dashboardPath}/promoter-production-cashback-commission`, { params })
    .then(({ data }) => data);
}

export async function getExternalDashboardUrls() {
  return http
    .get('/dashboard/external')
    .then(({ data }) => data);
}

export async function getBusinessGoals() {
  return http
    .get('/dashboard/business-goals')
    .then(({ data }) => data);
}

export async function getPromoterDemographics(params) {
  return http
    .get(`${dashboardPath}/promoter-demographics`, { params })
    .then(({ data }) => data);
}

export async function getFlowBreakdown(params) {
  return http
    .get(`${dashboardPath}/flow-breakdown`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getFunnelEfficiency(params) {
  return http
    .get(`${dashboardPath}/funnel-efficiency`, { params })
    .then(({ data }) => data);
}

export async function getConversionFunnel(params) {
  return http
    .get(`${dashboardPath}/conversion-funnel`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getRiskConcentration(params) {
  return http
    .get(`${dashboardPath}/risk-concentration`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCltEligibility(params) {
  return http
    .get(`${dashboardPath}/clt-eligibility`, { params })
    .then(({ data }) => data);
}

export async function getCltCompanies(params) {
  return http
    .get(`${dashboardPath}/clt-companies`, { params })
    .then(({ data }) => data);
}

export async function getCltRefusals(params) {
  return http
    .get(`${dashboardPath}/clt-refusals`, { params })
    .then(({ data }) => data);
}

export async function getCltBorrowerEligibility(params) {
  return http
    .get(`${dashboardPath}/clt-borrower-eligibility`, { params })
    .then(({ data }) => data);
}

export async function getBorrowerDemographics(params) {
  return http
    .get(`${dashboardPath}/borrower-demographics`, { params })
    .then(({ data }) => data);
}

export async function getCltBorrowerProfile(params) {
  return http
    .get(`${dashboardPath}/clt-borrower-profile`, { params })
    .then(({ data }) => data);
}

export async function getProductionBreakdown(params) {
  return http
    .get(`${dashboardPath}/production-breakdown`, { params })
    .then(({ data }) => data);
}

export async function getSystemErrors(params) {
  return http
    .get(`${dashboardPath}/system-errors`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getAuctionFunnel(params) {
  return http
    .get(`${dashboardPath}/auction-funnel`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

// Funil genérico por product_id/supplier_id (funnel_events). B2B-257 (CLT via
// QiTech) e B2B-258 (CGV) reutilizam esta MESMA chamada — só o product_id (e,
// pro CGV, o supplier_id vindo do filtro global) muda entre painéis.
export async function getFunnelEventsConversion(params) {
  return http
    .get(`${dashboardPath}/funnel-events-conversion`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCardFunnel(params) {
  return http
    .get(`${dashboardPath}/card-funnel`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getPromoterHealth(params) {
  return http
    .get(`${dashboardPath}/promoter-health`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCrossSell(params) {
  return http
    .get(`${dashboardPath}/cross-sell`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getThroughputHeartbeat(params) {
  return http
    .get(`${dashboardPath}/throughput-heartbeat`, { params })
    .then(({ data }) => data);
}

export async function getCommercialGoals(params) {
  return http
    .get(`${dashboardPath}/commercial-goals`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCommercialReactivations(params) {
  return http
    .get(`${dashboardPath}/commercial-reactivations`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCommercialPendingByIssueType(params) {
  return http
    .get(`${dashboardPath}/commercial-pending-by-issue-type`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getReactivatedHealth(params) {
  return http
    .get(`${dashboardPath}/reactivated-health`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

// Painel consolidado "Dono da Promotora" (B2B-273). Escopo travado no back pela RLS do usuário.
export async function getOwnerOverview(params) {
  return http
    .get('/dashboard/dashboard-owner/overview', { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

// Versão global (Diretoria — B2B-275): mesmas métricas do dono, sem travar numa promotora.
export async function getDirectorOverview(params) {
  return http
    .get('/dashboard/dashboard-admin/director-overview', { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

// Segmentação de promotoras por média de pagas/semana (B2B-281).
export async function getPromoterSegmentation(params) {
  return http
    .get(`${dashboardPath}/promoter-segmentation`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}
